import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { type CustomAxiosConfig, maxios } from '../../lib/maxios/maxios';
import type { ShopifySubscriptionResponseDto } from '../../lib/types';
import { handleApiError } from '../utils/handle-api-error/handleApiError';

const ENDPOINT = 'verify_subscription';

export const verifySubscription = async (storeId: string): Promise<boolean> => {
    const url = pathfinder('ai_store_builder_api_get', {
        version: 'v1',
        store_id: storeId,
        endpoint: ENDPOINT,
    });

    const options: Partial<CustomAxiosConfig> = {
        routeKey: ENDPOINT,
    };

    try {
        const { data } = await maxios.get<ShopifySubscriptionResponseDto>(url, options);

        return data.subscription;
    } catch (error) {
        logger.error(error as Error, {
            description: 'Failed to verify subscription',
            store_id: storeId,
        });

        throw handleApiError(error);
    }
};
